import { fork } from 'redux-saga/effects';

import { actions } from 'domain/consideration';
import { itemNavigator } from 'sagas/common';

export default function* navigator(args) {
  yield fork(itemNavigator, { modelName: 'Consideration', actions, editableFields: [] }, args);
}
